import { MouseEvent, useState } from "react";
import { Link, Theme, useTheme } from "@mui/material";
import CourseDetailsModalDialog from "pages/CourseCatalog/CourseDetailsModalDialog";
import useGlobalContext from "hooks/globalData";

const useStyles = (theme: Theme) => ({
  link: {
    textAlign: "left",
  },
});

type CourseTitleCellProps = {
  skuId: string;
  title: string | undefined;
};

export function CourseTitleCell({
  skuId,
  title,
}: Readonly<CourseTitleCellProps>) {
  const [modalOpen, setModalOpen] = useState(false);
  const styles = useStyles(useTheme());
  const { courseDetailsUrl } = useGlobalContext();

  function handleClick(event: MouseEvent<HTMLAnchorElement>): void {
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.button !== 0) {
      return;
    }
    event.preventDefault();
    setModalOpen(true);
  }

  function handleClickClose(): void {
    setModalOpen(false);
  }
  return (
    <>
      <Link
        sx={styles.link}
        underline="hover"
        href={courseDetailsUrl(skuId)}
        onClick={handleClick}
      >
        {title}
      </Link>
      <CourseDetailsModalDialog
        skuId={skuId}
        open={modalOpen}
        onClose={handleClickClose}
      />
    </>
  );
}
